/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M6 7a.75.75 0 0 0 0 1.5h11.25a.75.75 0 0 0 0-1.5H6ZM6 12.25a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5H6Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M0 5.5C0 3.0147 2.0147 1 4.5 1h15C21.9853 1 24 3.0147 24 5.5v9c0 2.4853-2.0147 4.5-4.5 4.5H7.8347a4.5 4.5 0 0 0-3.887 2.2326l-1.152 1.9748C2.0242 24.53 0 23.9827 0 22.4516V5.5Zm4.5-3h15c1.6569 0 3 1.3432 3 3v9c0 1.6569-1.3431 3-3 3H7.8347a6 6 0 0 0-5.1827 2.9768L1.5 22.4516V5.5c0-1.6568 1.3432-3 3-3Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'Comment'
);
